<template>
  <IconButton
    btn-style="primary"
    name="phone-call"
    color="none"
    :size="12"
    @click.native="openDialog"
  >
    ¡Te llamamos!
  </IconButton>
</template>

<script>
import { createDialog } from '@/lego/dialogs/weCallYou';
import IconButton from '@/lego/components/buttons/IconButton.vue';

export default {
  components: {
    IconButton,
  },
  setup() {
    function openDialog() {
      const dialog = createDialog();
      dialog.show();
    }

    return {
      openDialog,
    };
  },
};
</script>
